import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetClubInfoByAdminUtils(club, allAvailableHours = null, courts = null, salesChannels = null) {
  let url = "/reservation/club_info_by_admin_utils/" + club;

  const params = new URLSearchParams();

  if (allAvailableHours !== null) params.append("allAvailableHours", allAvailableHours);
  if (courts !== null) params.append("courts", courts);
  if (salesChannels !== null) params.append("salesChannels", salesChannels);

  const queryString = params.toString();
  if (queryString) {
    url += "?" + queryString;
  }

  return FetchGetDataWithAuthNEW(url);
}